module.exports = __webpack_public_path__ + "static/media/U.4da9fc59.svg";